import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import _get from 'lodash/get'
import config from '~/config'

import { withGoogleMap, withScriptjs, GoogleMap } from 'react-google-maps'
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'
import { MAP } from 'react-google-maps/lib/constants'
import { withProps } from 'recompose'
import { Input, Icon } from 'antd'

import { WindMap } from '~/wind/wind'
import CanvasLayerFactory from '~/canvas-layer-factory'
import DataDateSearch from '~/components/DataDateSearch'
import Station from '~/components/Station'
import SelectedStation from '~/components/SelectedStation'
import POI from './POI'
import SelectedPOI from './SelectedPOI'
import SalinityLegend from '~/components/SalinityLegend'
import poisQuery from '~/graphql/queries/pois.gql'
import createPoiMutation from '~/graphql/mutations/createPoi.gql'
// import user from '~/user.json'

const defaultCenter = _get(config, 'ui.map.defaultCenter')
const defaultZoom = _get(config, 'ui.map.defaultZoom')

@inject('view')
@inject('data')
@inject('user')
// @inject('userPoi')

@withProps(({ data }) => ({
  googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&v=3.36&libraries=drawing,places`,
  loadingElement: <div style={{ height: `100%` }} />,
  containerElement: <div style={{ height: `100%` }} />,
  mapElement: <div style={{ height: `100%` }}/>
}))
@withScriptjs
@withGoogleMap
@graphql(poisQuery, {
  props: ({ data: { loading, pois, refetch } }) => ({
    loading,
    refetch,
    pois: _get(pois, 'nodes', [])
  }),
  options: ({ user: { profile } }) => ({
    variables: {
      userId: profile.userId
    }
  })
})
@graphql(createPoiMutation, {
  props: ({ ownProps, createPoi }) => ({
    createPoi: ({ userId, poiName, latitude, longitude }) =>
      createPoi({
        variables: { userId, poiName, latitude, longitude },
        update: (store, { data: { createPoi } }) => {
          const data = store.readQuery({ query: poisQuery, variables: { userId, active: true } })
          data.pois.nodes.push(createPoi.poi)
          store.writeQuery({ query: poisQuery, variables: { userId, active: true }, data })
        }
      })
  }),
  name: 'createPoi'
})
@observer
class DataMap extends Component {
  windMap = null
  map = null
  _map = null
  searchBox = null
  state = {
    bounds: null,
    data: null
  }
  resetZoom = () => {
    this._map.setZoom(defaultZoom)
    this._map.setCenter(defaultCenter)
  }
  onPlacesChanged = () => {
    const { user: { profile } } = this.props
    // const { userPoi } = this.props
    const [place] = this.searchBox.getPlaces()
    const position = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    }

    this.props.createPoi({
      userId: profile.userId,
      poiName: place.name,
      latitude: position.lat,
      longitude: position.lng
    }).then(res => {
      const poi = _get(res, 'data.createPoi.poi')
      if (poi && poi.id) {
        this.props.view.addPoiId(poi.id)
        this.props.data.addPoi(poi)
      }
    })
    if (!this._map.getBounds().contains(position)) {
      this._map.panTo(position)
    }
    // userPoi.addPOI(poi)
  }
  onMapMounted = ref => {
    this.map = ref || this.map
    this._map = this.map.context[MAP]

    const CanvasLayer = CanvasLayerFactory(google) // eslint-disable-line no-undef
    google.maps.event.addListenerOnce(this._map, 'idle', () => { // eslint-disable-line no-undef
      this.windMap = new WindMap({
        canvas: new CanvasLayer({ map: this._map }).canvas,
        colorScheme: [
          [0.00, [116, 171, 61]],
          [0.20, [247, 206, 70]],
          [0.25, [200, 42, 56]]
        ],
        extent: () => {
          return {
            width: this.map.getDiv().clientWidth,
            height: this.map.getDiv().clientHeight,
            latlng: [
              [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getSouthWest().lat()],
              [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat()]
            ]
          }
        }
      })
    })
  }
  onSearchBoxMounted = ref => {
    this.searchBox = ref
  }
  poiClick = poiId => {
    this.props.view.addPoiId(parseInt(poiId, 10))
  }
  render () {
    const { view: { stationIds = [], poiIds }, data: { salinityOverlayData, mainStationId, stations = [], salinityData }, pois } = this.props
    const MyMapStyle = [
      {
        'featureType': 'all',
        'elementType': 'all',
        'stylers': [
          {
            'hue': '#0087ff'
          },
          {
            'visibility': 'on'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'weight': '2.30'
          },
          {
            'color': '#ff0000'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text',
        'stylers': [
          {
            'weight': '5.91'
          },
          {
            'visibility': 'on'
          },
          {
            'color': '#ff0000'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.fill',
        'stylers': [
          {
            'color': '#357cbb'
          },
          {
            'visibility': 'on'
          },
          {
            'weight': '5.79'
          },
          {
            'gamma': '1.76'
          },
          {
            'lightness': '-47'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.text.stroke',
        'stylers': [
          {
            'color': '#1e73be'
          },
          {
            'weight': '3.15'
          },
          {
            'lightness': '100'
          },
          {
            'visibility': 'on'
          },
          {
            'gamma': '1.64'
          }
        ]
      },
      {
        'featureType': 'all',
        'elementType': 'labels.icon',
        'stylers': [
          {
            'color': '#1e73be'
          },
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'administrative.land_parcel',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'off'
          },
          {
            'color': '#ff0000'
          }
        ]
      },
      {
        'featureType': 'landscape',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'landscape.man_made',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'landscape.natural',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#00fff6'
          }
        ]
      },
      {
        'featureType': 'landscape.natural',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'off'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.landcover',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#ff0000'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.landcover',
        'elementType': 'geometry.stroke',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.terrain',
        'elementType': 'all',
        'stylers': [
          {
            'visibility': 'on'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.terrain',
        'elementType': 'geometry',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.terrain',
        'elementType': 'geometry.fill',
        'stylers': [
          {
            'visibility': 'on'
          },
          {
            'hue': '#0087ff'
          }
        ]
      },
      {
        'featureType': 'landscape.natural.terrain',
        'elementType': 'labels.icon',
        'stylers': [
          {
            'hue': '#0087ff'
          },
          {
            'visibility': 'on'
          }
        ]
      }
    ]

    const data = salinityOverlayData.get()

    const salinityRecords = salinityData.get()

    if (this.windMap) {
      this.windMap.update({
        data,
        velocityScale: 0.00005

      }, true)
    }

    return <div>
      <GoogleMap
        onBoundsChanged={() => this.setState({
          bounds: this.map.getBounds()
        })}
        onZoomChanged={() => ({ onZoomChange }) => {
          onZoomChange(this.map.getZoom())
        }}
        options={{
          mapTypeControl: true,
          zoomControl: true,
          fullscreenControl: false,
          gestureHandling: 'auto',
          styles: MyMapStyle,
          streetViewControl: false
        }}
        ref={this.onMapMounted}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
      >
        <SearchBox
          ref={this.onSearchBoxMounted}
          onPlacesChanged={this.onPlacesChanged}
          controlPosition={google.maps.ControlPosition.TOP_LEFT} // eslint-disable-line no-undef
          bounds={this.state.bounds}
        >
          <div
            style={{
              marginTop: '10px',
              width: '300px',
              textAlign: 'center'
            }}
          >
            <Input
              type="text"
              placeholder="ค้นหา"
              style={{
                width: `275px`
              }}
              addonAfter={<Icon type="reload" style={{ cursor: 'pointer' }} onClick={() => this.resetZoom()}/>}
            />
            <DataDateSearch />
          </div>
        </SearchBox>
        {stations.map(station =>
          stationIds.includes(station.id) ? (
            <SelectedStation
              key={station.id}
              station={station}
              main={station.id === mainStationId}
              salinityRecords={_get(salinityRecords, `s${station.id}`, [])}
            />
          ) : (
            <Station
              key={station.id}
              station={station}
              main={station.id === mainStationId}
              salinityRecords={_get(salinityRecords, `s${station.id}`, [])}
            />
          )
        )}
        {pois && pois.map((poi, index) =>
          poiIds.includes(poi.id) ? (
            <SelectedPOI
              poi={poi}
              key={index}
              salinityRecords={_get(salinityRecords, `p${poi.id}`, [])}
            />
          ) : (
            <POI
              poi={poi}
              key={index}
              onClick={() => this.poiClick(poi.id)}
              salinityRecords={_get(salinityRecords, `p${poi.id}`, [])}
            />
          )
        )}
      </GoogleMap>
      <SalinityLegend />
      <div style={{ position: 'absolute', bottom: '30px', right: '50px', backgroundColor: 'white', fontSize: 'large', padding: '.5em' }}>
        <a href="https://chaophraya.lsr.nectec.or.th/lowerchaophraya" target="_blank" rel="noopener noreferrer">ดูผลความละเอียดสูง</a>
      </div>
    </div>
  }
}

export default DataMap



// WEBPACK FOOTER //
// ./src/modules/Forecasting/DataMap.js